import React, { Component } from 'react';
import { Modal, Row, Col, Input, message } from 'antd';
import API_URL from '../../../../common/url';
import AjaxRequest from '../../../../common/AjaxRequest';

const TextArea = Input.TextArea;

class NextWeekPlan extends Component {
    state = {
        visible: false,
        confirmLoading: false,
    }

    show = params => {
        this.setState({
            visible: true,
            ...params,
        });
    };

    hide = () => {
        this.setState({ visible: false });
    };

    handleSubmit = () => {
        const { type,userId, startDate, endDate, enterpriseWorkNameValue } = this.state;
        const investigationSiteId = sessionStorage.getItem('siteId');
        const url = type == 'comment' ? API_URL.sumtotal.addUserWeeklyComment : API_URL.sumtotal.addCrcNextWeekly;
        const options = {
            url,
            data: {
                userId,
                content: enterpriseWorkNameValue,
                endDate,
                startDate,
                investigationSiteId,
            },
            dataType: 'json',
            doneResult: ( res => {
                if (res.success) {
                    message.success(res.success);
                } else if (res.error) {
                    message.error(res.error);
                }
                this.setState({ visible: false });
                this.props.reload();
            }),
        };
        AjaxRequest.sendRequest(options);
    };

    onTextAreaChange = e => {
        this.setState({ enterpriseWorkNameValue: e.target.value });
    }

    render() {
        const { visible, confirmLoading, enterpriseWorkNameValue, type } = this.state;
        return (
            <Modal
                title={type == 'comment' ? "填写本周备注" : "填写下周计划"}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
                confirmLoading={confirmLoading}
            >
                <Row>
                    <Col span={5}>{`${type == 'comment' ? "本周备注" : "下周计划"}：`}</Col>
                    <Col span={18}>
                        <TextArea placeholder={`请填写${type == 'comment' ? "本周备注" : "下周计划"}：`} value={enterpriseWorkNameValue} rows={4} onChange={this.onTextAreaChange} />
                    </Col>
                </Row>
            </Modal>
        );
    }
}

export default NextWeekPlan;



// WEBPACK FOOTER //
// ./src/components/sumTotal/crcWeekly/components/NextWeekPlan.js